import { Box } from "@mui/material";
import styled from "styled-components";

/**
 * Main grid container using CSS Grid layout
 * - First column is sticky (questions)
 * - Subsequent columns are data columns (one per report)
 */
export const GridContainer = styled(Box)<{ columnCount: number }>`
  display: grid;
  grid-template-columns: minmax(300px, 400px) repeat(${props => props.columnCount}, minmax(300px, 1fr));
  max-height: calc(100vh - 100px);
  overflow: auto;
  border-radius: 8px;
  border-top: 1px solid ${props => props.theme.colors.redesign.db20};
  border-left: 1px solid ${props => props.theme.colors.redesign.db20};
  background: ${props => props.theme.colors.white};
  margin: 16px 0;
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-track {
    background: ${props => props.theme.colors.redesign.db10};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.redesign.db40};
    border-radius: 4px;

    &:hover {
      background: ${props => props.theme.colors.redesign.db70};
    }
  }
`;
export const HeaderCell = styled(Box)`
  position: sticky;
  top: 0;
  z-index: 100;
  background: ${props => props.theme.colors.redesign.b5};
  padding: 16px;
  border-bottom: 2px solid ${props => props.theme.colors.redesign.db20};
  border-right: 1px solid ${props => props.theme.colors.redesign.db20};
  font-weight: 600;
  display: flex;
  align-items: center;
`;

export const QuestionsHeaderCell = styled(Box)`
  position: sticky;
  left: 0;
  top: 0;
  z-index: 101;
  background: ${props => props.theme.colors.redesign.b5};
  padding: 16px;
  border-right: 2px solid ${props => props.theme.colors.redesign.db20};
  border-bottom: 2px solid ${props => props.theme.colors.redesign.db20};
  display: flex;
  align-items: center;
  ${props => props.theme.belowBreakpoint} {
    left: initial;
  }
`;

export const QuestionCellContainer = styled(Box)<{ rowIndex?: number; isSubQuestion?: boolean }>`
  position: sticky;
  left: 0;
  z-index: 10;
  background: ${props =>
    props.rowIndex !== undefined && props.rowIndex % 2 === 1
      ? props.theme.colors.redesign.b5
      : props.theme.colors.white};
  padding: 16px;
  border-right: 2px solid ${props => props.theme.colors.redesign.db20};
  border-bottom: 1px solid ${props => props.theme.colors.redesign.db20};
  border-left: ${props => (props.isSubQuestion ? `8px solid ${props.theme.colors.redesign.b60}` : "none")};
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${props => props.theme.belowBreakpoint} {
    position: relative;
  }
`;

export const AnswerCellContainer = styled(Box)<{ hasChanged?: boolean; rowIndex?: number }>`
  position: relative;
  padding: ${props => props.theme.spacing.S_15};
  border-right: 1px solid ${props => props.theme.colors.redesign.db20};
  border-bottom: 1px solid ${props => props.theme.colors.redesign.db20};
  display: flex;
  align-items: center;
  background: ${props => {
    const shouldAlternate = props.rowIndex !== undefined && props.rowIndex % 2 === 1;
    if (props.hasChanged) {
      return `${shouldAlternate ? props.theme.colors.redesign.o20 : props.theme.colors.redesign.o10}`;
    }
    if (shouldAlternate) {
      return props.theme.colors.redesign.b5;
    }
    return props.theme.colors.white;
  }};
  transition: background-color 0.2s ease;
`;

export const ChangeIndicator = styled.div<{ severity?: "neutral" | "improvement" | "decline" }>`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${props => props.theme.colors.redesign.o100};
`;
